import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { IChecklistV2ReportParameter } from '@fi-shared/checklist/fi-checklist2-report/shared/fi-checklist2-report';
import { IItemsListAction2 } from '@fi-shared/fi-items-list/fi-items-list';
import { FiItemsListOptionType } from '@fi-shared/fi-items-list/fi-items-list-option-type';
import { AppTextService } from '@fi-shared/app-text';
import { FiDialogsService } from '@fi-shared/fi-dialogs';

// todo: remove
@Component({
    selector: 'fi-checklist2-report-widget-menu',
    templateUrl: './fi-checklist2-report-widget-menu.component.html',
    styleUrls: ['./fi-checklist2-report-widget-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-checklist2-report-widget-menu' },
    standalone: false,
})
export class FiChecklist2ReportWidgetMenuComponent implements OnInit {
    @Input({ required: true }) reportParameter: IChecklistV2ReportParameter;
    @Output() deleteReportParameterClick = new EventEmitter<void>();

    actions: IItemsListAction2<IChecklistV2ReportParameter>[];

    constructor(
        private appTextService: AppTextService,
        private fiDialogsService: FiDialogsService,
    ) {}

    ngOnInit(): void {
        this.setActions();
    }

    isChecklistReportWidgetMenuTriggerShown() {
        return !!this.actions.find((action) => action.condition(this.reportParameter));
    }

    private isReportParameterDefault() {
        return !this.reportParameter.Name;
    }

    private setActions() {
        this.actions = [
            {
                title: this.appTextService.get('checklist.delete_report_widget'),
                condition: (data) => {
                    return !this.isReportParameterDefault();
                },
                onClick: (data) => {
                    this.fiDialogsService
                        .confirm({
                            colorClass: 'red',
                            headerText: this.appTextService.get('checklist.delete_report_widget'),
                            headerIconClass: 'fa-light fa-trash red',
                            isTopCloseButtonShown: true,
                            messageText: this.appTextService.get('checklist.delete_report_widget_message'),
                            yesButtonText: this.appTextService.get('common.delete'),
                            preventUppercaseButtonLabel: true,
                            config: {
                                panelClass: 'fi-rounded-dialog-panel',
                                autoFocus: false,
                                restoreFocus: false,
                            },
                        })
                        .onYesButtonClick(() => {
                            this.deleteReportParameterClick.emit();
                        });
                },
                iconClass: 'fa-regular fa-trash',
                optionType: FiItemsListOptionType.Icon,
            },
        ];
    }
}
